enum UploadStates {
    pending = 0,
    uploading = 1,
    uploaded = 2,
    error = 3,
    canceled = 4
}

export default UploadStates;